// extracted by mini-css-extract-plugin
module.exports = {"burger":"Burger_burger__rJPaF","open":"Burger_open__HgQ7u"};